import { AclRoleService } from '@abovo/shared-auth';
import { NoContentModule, SvgIconModule } from '@abovo/shared-ui-components';
import { PageHistoryStore } from '@abovo/webvis-data-access';
import { PageWrapComponent } from '@abovo/webvis-ui';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
   templateUrl: './404-page.component.html',
   imports: [PageWrapComponent, NoContentModule, TranslatePipe, MatButton, SvgIconModule],
})
export class PageNotFoundComponent {
   private readonly router = inject(Router);
   private readonly pageHistoryStore = inject(PageHistoryStore);
   readonly isAdmin = inject(AclRoleService).isAdministrator;

   goBack() {
      const lastPage = this.pageHistoryStore.currentPage();
      void this.router.navigate([lastPage.url], { queryParams: lastPage.queryParams });
   }
}
